import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../../tableSettings";
import lockRed from '../../../../img/lock_red.png';
import AbstractListView, {
DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer
} from "../../../common/AbstractListView";
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import {
  CurrencyAmountRenderer, DateRenderer, DateTimeRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import useReportViewer from '../../../../hooks/useReportViewer';
import PrimaryButton from '../../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../../uiControls/CurrencyLabel';
import SmartTable from '../../../../uiControls/SmartTable';
import {JobNames} from "../../../../framework.core/JobNames";
import { DocumentType } from "../../../../framework.core/DocumentType";
import {agentPaymentList} from "../../tableSettings";
import UniqueLinkButton from "../../../../uiControls/UniqueLinkButton";
import {AgentPaymentListItem} from "../../../../fms.data/models/AgentPaymentListItem";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import HistoryViewPayment from '../../../reports/HistoryViewPayment';
import DeleteHistoryPaymentView from '../../../reports/DeleteHistoryPaymentView';
import IfmsModal from '../../../../ui/IfmsModal';
import { FmsSubMenu } from '../../../../constants/fmsSubMenu';
import { FmsSecTask } from '../../../../fms.core/constants';
import { CheckSubArgs } from '../../../../fms.report/args';
import { findSecurityTask, getSecBySecTask } from '../../../../util';
import useSuntekSettings from '../../../../hooks/useSuntekSettings';
import { useJournal } from '../../general/journal/JournalListView';
import { formatDate, nowDate } from '../../../../dateUtils';
import AgentBalanceDetails from '../../../reports/AccountBalance';
import { SecType } from '../../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../../common/commonExportFormat';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function VoidDateRenderer({cell, row}:any) {
  return (
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default ifms-table-date data-row-fontred">
      {formatDate(cell.value)}
    </div>
  );
}

function TypeRenderer({ cell ,data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lPayment = (l as any).payment as string;
  if (lPayment === 'C') dataTooltip = 'CHECK';
  else if( lPayment === 'W') dataTooltip = 'W/T';
  else if( lPayment === 'O') dataTooltip = 'OFFSET';

  return (
    <div  className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ textAlign: 'center'}}>{cell.value}</div>
  );
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    &nbsp;
  </div>;
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const selectedElement = jobListContext.selectedElement as AgentPaymentListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acAgentPayment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    // New Mode와 Edit Mode를 동시에 열 수 없도록 수정
    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acAgentPayment/edit')) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }

    openNewPage(history, '/accounting/acAgentPayment/add', NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Agent Payment first', false, null, "warning");
      return;
    }

    if (!selectedElement.isDraft) {
      await showGlobalOkDialog('Can delete the Draft Payment', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (doDelete) {
      
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AgntPayment, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message);
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =  `/accounting/acAgentPayment/edit/${id}`;
    const viewUrl = `/accounting/acAgentPayment/view/${id}`;
    if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/accounting/acAgentPayment/edit', editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }
    // New Mode와 Edit Mode를 동시에 열 수 없도록 수정
    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acAgentPayment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =  `/accounting/acAgentPayment/edit/${id}`;
    const viewUrl = `/accounting/acAgentPayment/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acAgentPayment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/accounting/acAgentPayment/add?copyId=${id}`, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AgntPayment}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return {create, deleteItem: deleteItem, edit, view, copy, moveToDeleteHistoryReport};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);

  const appContext = useContext(ApplicationContext);
  
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd  },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="agentPayment-list-sub-menu"  width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AgentPaymentListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalPayment && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.AgntPayment, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as AgentPaymentListItem;

  const {deleteItem, edit, view, moveToDeleteHistoryReport, /*copy*/} = useSelectedOperations();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();
  const [showGlobalOkDialog] = useGlobalOkDialog();

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/view/${id}`);
  }
  
  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function print() {
    if (!selectedElement) {
      return;
    }

    const title = `Deposit Slip [${selectedElement?.checkNo}]`;
    const args = new CheckSubArgs({
      docType: DocumentType.CheckSub,
      formCaption: title,
      subject: title,

      tbId: selectedElement?.id.toString() ?? '',
      tbName: "T_DEPOHD"
    });

    viewReport(args, "", true);
  }

  async function agentBalance() {
    if (selectedElement.agentId <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Agent.</p>, false, null, 'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <AgentBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.AgntPayment}
          onPopupClose={onPopupClose}
          toDate={nowDate()}
          comId={selectedElement.agentId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.firstAgent}
        />
    })
  }

  const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);
  const readSecDelHistory = getSecBySecTask(appContext, FmsSecTask.AcctAPayDeleteHistory, SecType.Read);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='agentPayment-list-add-button' display="primary" size="regular" link="/accounting/acAgentPayment/add" disabled={!canBeAdd} label="New"/>&nbsp;
        <PrimaryButton name='agentPayment-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='agentPayment-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='agentPayment-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={edit}>Delete</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton name='agentPayment-list-history-button' size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1240, popupComponent: <HistoryViewPayment jobId={selectedElement.id} jobType={FmsSubMenu.CPHistory} /> })}>View History</PrimaryButton>&nbsp;
        { readSecDelHistory && <><PrimaryButton name='agentPayment-list-deleteHistory-button' size="regular" onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>&nbsp;</> }
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton name='agentPayment-list-print-button' size="regular" disabled={!hasSelectedRow} onClick={print}>Print Deposit Slip</PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);
  const history = useHistory();

  const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  function onLinkToAccounting(entity: any) {
    if (!entity || !entity.category || !entity.number) {
      return;
    }

    if (entity.category === 'Bill') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/bill/accounting', 'billNo', 'Bill #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/bill/accounting`, NavigationType.newPage);
    }
    if (entity.category === 'Invoice') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/accounting', 'invoiceNo', 'Invoice #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/invoice/accounting`, NavigationType.newPage);
    }
    if (entity.category === 'CrDb') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/accounting', 'crdbNo', 'CrDb #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/crdb/accounting`, NavigationType.newPage);
    }
  }

  async function loadInfoAreaInvoiceBillCrDb(id: string) {
    const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
    if (!apiResult) {
      return null;
    }

    const tableOptions: ApplicableTableSettings = {
      tableName: 'infoAreaBicTable',
      ...infoAreaBicTable,
      data: apiResult,
      
      rowRenderers: [
        {accessor: 'date', Cell: TextRenderer},
        {accessor: 'category', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting)},
        {accessor: 'companyName', Cell: TextAlignLeftRenderer},
        {accessor: 'cur', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true)},
      ],
    };

    return (
      <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
        <SmartTable {...tableOptions} />
      </div>
    );
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.AgntPayment}
      //entityId={(jobListContext.selectedElement as AgentPaymentListItem | null)?.id}
      jobId={(jobListContext.selectedElement as AgentPaymentListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Agent Payment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AgntPayment,
      'AgentPaymentListItem',
      AgentPaymentListItem.calculateSearchParameters(search, AgentPaymentListItem.MapSearchFields),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: AgentPaymentListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      {accessor: 'status', Cell: IndicatorRenderer},
      {accessor: 'isDraft', Cell: NullableCheckboxIconRenderer},
      {accessor: 'block', Cell: NullableCheckboxIconRenderer},
      {accessor: 'void', Cell: NullableCheckboxIconRenderer, Header: () => <div data-tooltip="Void">V</div>},
      {accessor: 'customer', Cell: TextAlignLeftRenderer},
      {accessor: 'receivedFrom', Cell: TextAlignLeftRenderer},
      {accessor: 'payment', Cell: TypeRenderer},
      {accessor: 'checkNo', Cell: TextAlignLeftRenderer},
      {accessor: 'bank', Cell: TextAlignLeftRenderer},
      {accessor: 'currency', Cell: TextRenderer},
      {accessor: 'amount', Cell: (props:any) => <CurrencyAmountRenderer currencyAccessor={(x:any) => x.currency} {...props} />},
      {accessor: 'chkPrint', Cell: TextRenderer},
      {accessor: 'invoiceNo', Cell: TextAlignLeftRenderer},
      {accessor: 'invBillCrdb', Cell: TextAlignLeftRenderer},
      {accessor: 'remark', Cell: TextAlignLeftRenderer},
      {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
      {accessor: 'u2ID', Cell: TextAlignLeftRenderer},

      {accessor: 'postDate', Cell: DateRenderer},
      {accessor: 'depositDate', Cell: DateRenderer},
      {accessor: 'voidDate', Cell: VoidDateRenderer},
      {accessor: 'u2Date', Cell: DateTimeRenderer},
      {accessor: 'u1Date', Cell: DateTimeRenderer},
    ];
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'isDraft', changedValue: (value: any) => { return nullableCheckBoxValue(value['isDraft'])} });
    colRenderer.push({ accessor: 'block', changedValue: (value: any) => { return nullableCheckBoxValue(value['block'])} });
    colRenderer.push({ accessor: 'void', changedValue: (value: any) => { return nullableCheckBoxValue(value['void'])} });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'voidDate', changedValue: (value: any) => { return formatDate(value['voidDate']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  agentPaymentList;
    const cols = AgentPaymentListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: AgentPaymentListItem) {
    return row && row.id ? `/accounting/acAgentPayment/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Agent Pay List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AgntPayment} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
